// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"11":"2a7de918","83":"15e56e67","681":"95a1a84d"}[chunkId] + ".css";
};